import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  LineChart as ReLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

import { mapAndSortLeadCount, PeriodView } from "./helpers/chartPeriod";

interface LineChartProps {
  leadCount?: any[];
  view?: PeriodView; // "date" | "month" | "year"
}

const LineChart: React.FC<LineChartProps> = ({
  leadCount = [],
  view = "date",
}) => {
  const data = useMemo(() => {
    const base = (leadCount || []).map((item: any) => ({
      period: String(item.period ?? ""),
      hot: Number(item.highIntent ?? 0),
      warm: Number(item.mediumIntent ?? 0),
      interested: Number(item.lowIntent ?? 0),
    }));

    return mapAndSortLeadCount(base, view);
  }, [leadCount, view]);

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={330}>
          <ReLineChart
            data={data}
            margin={{ top: 10, right: 16, left: 0, bottom: 0 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              opacity={0.25}
            />

            <XAxis
              dataKey="period"
              tickLine={false}
              axisLine={false}
              minTickGap={18}
              tick={{ fontSize: 12 }}
            />

            <YAxis
              tickLine={false}
              axisLine={false}
              allowDecimals={false}
              tick={{ fontSize: 12 }}
            />

            <Tooltip
              cursor={{ opacity: 0.08 }}
              contentStyle={{
                borderRadius: 12,
                border: "1px solid rgba(0,0,0,0.08)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              }}
              labelStyle={{ fontWeight: 700 }}
            />

            <Legend verticalAlign="top" height={30} iconType="circle" />

            <Line
              type="monotone"
              dataKey="hot"
              name="High Intent"
              stroke="#065f46"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 5 }}
            />

            <Line
              type="monotone"
              dataKey="warm"
              name=" Medium Intent"
              stroke="#3730a3"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 5 }}
            />

            <Line
              type="monotone"
              dataKey="interested"
              name="Low Intent"
              stroke="#374151"
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 5 }}
            />
          </ReLineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default LineChart;
